import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  declare readonly dialogTarget: HTMLElement
  private closeListener!: () => void
  private escListener!: (event: KeyboardEvent) => void

  connect(): void {
    console.log("Connected modal")
    this.closeListener = () => this.close()
    this.escListener = (event: KeyboardEvent) => { if (event.key === "Escape") this.close() }
    window.addEventListener("modal:close", this.closeListener)
    document.addEventListener("keydown", this.escListener)
  }

  disconnect(): void {
    console.log("Disconnected modal")
    window.removeEventListener("modal:close", this.closeListener)
    document.removeEventListener("keydown", this.escListener)
  }

  close(): void {
    const frame = document.getElementById("modal")
    if (frame) frame.innerHTML = ""
  }

  backdropClose(event: MouseEvent): void {
    if (event.target === this.element) this.close()
  }

  stop(event: Event): void {
    event.stopPropagation()
  }
}